import { QuestionnaireLandingPage } from './QuestionnaireLandingPage';
import { getBackgroundImageUrlHome } from '@/utils/nutrition/getImageUrl';
import { useState } from 'react';
import { LocalStorage, KEYS } from '@/utils/LocalStorage';
import { useCancerDetectUser } from '@/hooks/useCancerDetectUser';
import environment from '@/config/environment';
import TokenManager from '@viome/viome-base/src/api/TokenManager';
import { Loader } from '@/components/design-system/Loader';

export const QuestionnairesPage = () => {
  const localStorageUser = LocalStorage.getItem(KEYS.BOOTUP);
  const { enableNewQuestionnaire } = localStorageUser
    ? JSON.parse(localStorageUser)
    : { enableNewQuestionnaire: false };
  const { isCancerDetectClicked } = useCancerDetectUser();
  const [iframeLoading, setIframeLoading] = useState(true);

  if (enableNewQuestionnaire) {
    return (
      <div
        className="h-full flex flex-col"
        style={{
          backgroundImage: `url(${getBackgroundImageUrlHome('questionnaires-bg.png')})`,
          backgroundSize: 'cover',
        }}
      >
        <QuestionnaireLandingPage />
      </div>
    );
  }

  const OLD_QUESTIONNAIRES_PAGE_URL = `${environment.OLD_BASE_URL}/more/questionnaires?in_iframe=true&cancer_detect_ui=${isCancerDetectClicked}&token=${TokenManager.getAuthToken()}`;
  const IFRAME_HEIGHT = '100%';
  const IFRAME_WIDTH = '100%';

  return (
    <div>
      {iframeLoading && <Loader />}
      <iframe
        src={OLD_QUESTIONNAIRES_PAGE_URL}
        height={IFRAME_HEIGHT}
        width={IFRAME_WIDTH}
        style={{ height: '100vh' }}
        frameBorder="0"
        allowFullScreen
        onLoad={() => setIframeLoading(false)}
      />
    </div>
  );
};
